import { useState } from 'react';
import { SparklesIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../context/AuthContext';

const STORAGE_KEY = 'wrg_issue_reporter_announce_dismissed_v1';

const readDismissed = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

const IssueReporterAnnouncementBanner = () => {
  const { isImpersonating } = useAuth();
  const [dismissed, setDismissed] = useState(readDismissed);

  const open = !dismissed && !isImpersonating;

  const handleDismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      /* private mode / storage disabled — still hide for this session */
    }
    setDismissed(true);
  };

  return (
    <div className="collapsible-panel" data-open={open} aria-hidden={!open}>
      <div className="collapsible-inner">
        <div className="bg-blue-50 text-blue-900 border-b border-blue-200">
          <div className="pl-4 lg:pl-72 pr-4 py-2 sm:pr-6 lg:pr-8">
            <div className="flex items-center justify-between gap-x-3">
              <div className="flex items-center gap-x-3 min-w-0">
                <SparklesIcon
                  className="size-5 flex-shrink-0 text-blue-600"
                  aria-hidden="true"
                />
                <p className="text-sm font-medium">
                  <span className="font-semibold">New:</span> spotted a bug or
                  have a feature idea? Use the{' '}
                  <span className="font-semibold">Report Issue</span> button at
                  the top of any page, next to your avatar.
                </p>
              </div>
              <button
                type="button"
                onClick={handleDismiss}
                aria-label="Dismiss announcement"
                tabIndex={open ? 0 : -1}
                className="inline-flex items-center rounded-md p-1.5 hover:bg-blue-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 transition-colors"
              >
                <XMarkIcon className="size-4" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IssueReporterAnnouncementBanner;
